
import { useEffect, useCallback, useMemo, useState, useRef, useContext, useImperativeHandle, forwardRef, } from "react";
import { AgGridReact } from '@ag-grid-community/react';
import { InfiniteRowModelModule } from '@ag-grid-community/infinite-row-model';

/*import '@ag-grid-community/styles/ag-grid.css';
import "@ag-grid-community/styles/ag-theme-quartz.css";*/
import '@ag-grid-community/styles/ag-grid.css';
import "@ag-grid-community/styles/ag-theme-balham.css"; 
import "./customStyles.css";

import { ModuleRegistry } from '@ag-grid-community/core';
import { DDD, E2Data } from "../../lib/ddd/ddd";
import {currencyToCountryMap} from "./currency_flags";
import { ReactComponent as EditBtn } from "../../assets/enter.svg";
import { ReactComponent as CopyBtn } from "../../assets/copy.svg";
import classes from "./CustomersGrid.module.scss";
import { NotificationManager} from 'react-notifications';
import useEffectIgnoreFirst from "../../hooks/useEffectIgnoreFirst";
import { useTranslation } from 'react-i18next';
import { OrgIdContext } from "../../store/orgId_context";
import HelpIcon from '@mui/icons-material/Help';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import JoinFullIcon from '@mui/icons-material/JoinFull';
import JoinInnerIcon from '@mui/icons-material/JoinInner';
import TagIcon from '@mui/icons-material/Tag';
import SummarizeIcon from '@mui/icons-material/Summarize';
import AssuredWorkloadIcon from '@mui/icons-material/AssuredWorkload';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import ApprovedIcon from '@mui/icons-material/CheckCircle';
import RejectedIcon from '@mui/icons-material/Cancel';
import PaymentIcon from '@mui/icons-material/AttachMoney';
import CancelledIcon from '@mui/icons-material/HighlightOff';
import SentIcon from '@mui/icons-material/Send';
import ErrorIcon from '@mui/icons-material/ErrorOutline';
import StornoIcon from '@mui/icons-material/Replay';
import QuarantineIcon from '@mui/icons-material/ReportProblem';
import ArchivedIcon from '@mui/icons-material/Archive';
import SeenIcon from '@mui/icons-material/RemoveRedEye';
import RemindedIcon from '@mui/icons-material/NotificationsActive';
import WaitingIcon from '@mui/icons-material/Schedule';
import UnknownIcon from '@mui/icons-material/HelpOutline';
import {
    Receipt,         // Default invoice
    Description,     // Proforma
    EditNote,        // Corrective
    ReceiptLong,     // Construction-related
    Paid,            // Advance
    CreditScore,     // Credit note
    AttachMoney,     // Partial
    History,         // Self-invoice
    WarningAmber,    // Special cases,
    MonetizationOn, CreditCard, Payments, HelpOutline, // Payment types
    Storefront, BusinessCenter,
    MoveToInbox, // Sale types
    AccountBalance,
    CalendarToday,
    Schedule,
    Edit,
    CloudOff,
    Assignment,
    Business,
    Article,
    Email,
    Category,
    ListAlt,
    Label,    // For report types header
    Public,
    SwapHoriz,
    Gavel,Assessment,Home
} from '@mui/icons-material';
import { 
    Box, 
    Tooltip as MuiTooltip,
} from '@mui/material';
import PaidIcon from '@mui/icons-material/Paid';
import LooksOneIcon from '@mui/icons-material/LooksOne';
import DescriptionIcon from '@mui/icons-material/Description';
import StorefrontIcon from '@mui/icons-material/Storefront';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import PaymentsIcon from '@mui/icons-material/Payments';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import MessageIcon from '@mui/icons-material/Message';
import { normalizeLocaleCode } from "../../lib/normalizeLocaleCode";

ModuleRegistry.registerModules([InfiniteRowModelModule]);

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ddd = new DDD(apiRequestAddress);

const userPreferences = {
    __invoiceType: {
        order : 1,
        width: 60,
    },
    SeqNo: {
        order : 2,
        width: 60,
        sort: "desc",
    },
    ReportFrom: {
        order : 3,
        width: 150,
    },
    ReportTo: {
        order : 4,
        width: 150,
    },
    ReportDate: {
        order : 5,
        width: 150
    },
    ReportTime: {
        order : 6,
        width: 150,
    },
    TAPDateTime: {
        order : 8,
        width: 120,
    },
    UserCreate: {
        order : 9,
        width: 120,
    },
    CreateDateTime: {
        order : 10,
        width: 120,
    },
}
const VATReportsTable = forwardRef(({search, type, range, range2, source, state, reloadNum, filter, entityInfo, onRowSelect, tableModel, dateField, dateField2, stepsData, mode, onRightClick}, ref) =>{
    const table =useRef();
    const [requestParams, setRequestParams] = useState();
    const {sessionInfo, mainOrgId} = useContext(OrgIdContext)
    const [totalRecords, setTotalRecords] = useState("-");
    const [currentFilter, setCurrentFilter] = useState();
    const { t, i18n } = useTranslation();
    const userSettings = mergeObjects({...userPreferences},tableModel);

    useImperativeHandle(ref, () => ({
        getColumnSettings: getColumnSettings,
    }), [table, requestParams]);

    const columnDefs = useMemo(() => {
        const colArr = [{
            field : "__invoiceType",
            headerName : t(""),
            sortable : false,
            maxWidth:120,
            minWidth: 120,
            flex:1,
            cellStyle : {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                textAlign :"center"
            },
            headerComponent:  (props) => {
                    return (<>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", textAlign: "center", flex: 1 }}>    
                            <MuiTooltip title="Code" placement="top">
                            <ListAlt fontSize="small" />
                            </MuiTooltip>

                            <MuiTooltip title="Type" placement="top">
                            <Label fontSize="small" />
                            </MuiTooltip>

                            <MuiTooltip title="Source" placement="top">
                                <SwapHoriz fontSize="small" />
                            </MuiTooltip>
                            <MuiTooltip title="TAP status" placement="top">
                                <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="12" cy="12" r="10" 
                                            fill="#707171" 
                                            stroke="black" 
                                            stroke-width="1"/>
                                    <text x="12" y="15" 
                                            //font-family="Arial, sans-serif" 
                                            font-size="8" 
                                            //font-weight="bold" 
                                            text-anchor="middle" 
                                            fill="white">TAP</text>
                                </svg>
                            </MuiTooltip>
                        </div>
                    </>);
                },
            cellRenderer : (params) => {
                let color = 'white'
                switch (params?.data?.StepStatus) {
                    case 'Error':
                        color = 'white';
                        break;
                    case 'Warning':
                    case 'Pending':
                        //color = '#FFA500';
                        color = 'white';
                        break;
                    default:
                        break;
                }
                return (<> 
                <MuiTooltip title={params?.data?.ReportType__CodeName} placement="top">
                    <span>{getReportTypeIcon(params?.data?.ReportType__Code)}</span>
                </MuiTooltip>

                <MuiTooltip title={params?.data?.ReportType__PurposeType} placement="top">
                    <span>{getCategoryIcon(params?.data?.ReportType__PurposeType)}</span>
                </MuiTooltip>

                <MuiTooltip title={params?.data?.ReportType__Source} placement="top">
                    <span>{getInvoiceSourceIcon(params?.data?.ReportType__Source)}</span>
                </MuiTooltip>
                <MuiTooltip
                title={
                    <div>
                    {params?.data?.TAPStatus && (
                        <>
                        <strong>{t("Status")}:</strong> {params.data.TAPStatus}
                        <br />
                        </>
                    )}
                    {!params?.data?.TAPStatus && (
                        <>
                        <strong>{t("Status")}:</strong> {t("None")}
                        <br />
                        </>
                    )}
                    {params?.data?.TAPDesc && (
                        <>
                        <strong>{t("Comment")}:</strong> {params.data.TAPDesc}
                        </>
                    )}
                    </div>
                }
                placement="top"
                >
                <span>{getStatusIcon(params?.data?.TAPStatus)}</span>
                </MuiTooltip>
                </>)
            },
            ...userSettings.__invoiceType,
        },
        {
            field : "SeqNo",
            headerName : t("Sequence"),
            ...userSettings.SeqNo,

        },
        {
            field : "ReportFrom",
            headerName : t("From"),
            cellStyle : {
                textAlign :"center"
            },
            cellRenderer : (params) => {
                if (!params.value) return "";
                const date = new Date(params.value);
                return date.toLocaleString(normalizeLocaleCode(i18n.language), {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                });
            },
            ...userSettings.ReportFrom,
        },
        {
            field : "ReportTo",
            headerName : t("To"),
            cellStyle : {
                textAlign :"center"
            },
            cellRenderer : (params) => {
                if (!params.value) return "";
                const date = new Date(params.value);
                return date.toLocaleString(normalizeLocaleCode(i18n.language), {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                });
            },
            ...userSettings.ReportTo,
        },
        {
            field : "ReportDate",
            headerName : t("Report date"),
            cellStyle : {
                textAlign :"center"
            },
            cellRenderer : (params) => {
                if (!params.value) return "";
                const date = new Date(params.value);
                return date.toLocaleString(normalizeLocaleCode(i18n.language), {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                });
            },
            ...userSettings.ReportDate,
        },
        {
            field : "ReportTime",
            headerName : t("Report time"),
            cellStyle : {
                textAlign :"center"
            },
            ...userSettings.ReportTime,
        },
        {
            field : "TAPDateTime",
            headerName: t("Submitted"),
            headerComponent: TapHeaderComponent,
            cellStyle : {
                textAlign :"center"
            },
            sortable: true,
            cellRenderer : (params) => {
                if (!params.value) return "";
                const date = new Date(params.value);
                return date.toLocaleString(normalizeLocaleCode(i18n.language), {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                });
            },
            ...userSettings.TAPDateTime,
        },
        {
            field : "UserCreate",
            headerName : t("User"),
            sortable : true,
            ...userSettings.UserCreate,
        },
        {
            field : "CreateDateTime",
            headerName : t("Created"),
            cellStyle : {
                textAlign :"center"
            },
            cellRenderer : (params) => {
                if (!params.value) return "";
                const date = new Date(params.value);
                return date.toLocaleString(normalizeLocaleCode(i18n.language), {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false // Forces 24-hour format (e.g., "14:30" instead of "2:30 PM")
                });
            },
            ...userSettings.CreateDateTime,
        },
    ];
        return colArr
        .sort((a, b) => (a.order ?? 999) - (b.order ?? 999))
        .map(({ order, ...rest }) => rest);
    },[]);

    const getColumnSettings = () => {
        const columnApi = table.current?.api;
        if (!columnApi) return null;

        const columnState = columnApi.getColumnState(); // width + visible order
        const allColumns = columnApi.getAllGridColumns(); // for sort

        const settings = {};

        columnState.forEach((col, index) => {
            const gridCol = allColumns.find(c => c.getColId() === col.colId);

            settings[col.colId] = {
                order: index + 1,
                width: col.width,
                sort: gridCol?.getSort() ?? undefined,
                sortIndex: gridCol?.getSortIndex() ?? undefined,
            };
        });

        return settings;
    };

    const rowStyles = params => {
        const status = params?.data?.StepStatus;
        if (status === 'Error') return { backgroundColor: '#f8b3b3' };
        if (status === 'Warning') return { backgroundColor: '#d0d8ff' };
        if (status === 'Pending') return { backgroundColor: '#fdf0a1' };
        //if (status === 'OK') return { backgroundColor: '#c8f7c5' };
        return {};
    }

    const toClipboard = (val) =>{
        navigator.clipboard.writeText(val);
        NotificationManager.success(t("Copied"), "");
    }
    const defaultColDef = useMemo(() => {
        return {
            //flex: 1,
            minWidth: 100,
            sortable: true,
            tooltipShowDelay: 0,
        }
    }, []);

    const onGridReady = useCallback((params) => {
        const dataSource = {
            rowCount: undefined,
            getRows: (reqParams) => {
                setRequestParams(reqParams);
                reqParams.filter = filter;
                reqParams.mode = mode;
                loadEntityData(reqParams).then((res) =>{
                    setTotalRecords(res?.result?.count ?? "-");
                    reqParams.successCallback(res?.result?.data, res?.result?.count);
                    if (res?.result?.data?.length > 0) {
                        setTimeout(() => {
                            params.api.getDisplayedRowAtIndex(0)?.setSelected(true);
                        }, 0);
                    }
                });
            }
        }
        params.api.setGridOption('datasource', dataSource);
    });

    const loadEntityData = ({startRow,endRow,search,filter,range,range2,type,state,mode,sortModel,source}) => {
        const e2data= new E2Data("EU_VATReports");
        e2data.format="Full"
        e2data.includeCount=true;
        e2data.skip=startRow;
        e2data.take=endRow-startRow;
        e2data.component= "*";
        e2data.filter=getFilterFromSearch(search, filter, range, range2, type, state, mode,source);
        setCurrentFilter(getDisplayFilter(search, filter, range, range2, type, state, mode,source));
        e2data.orderBy=getOrderByFromArray(sortModel);
        return e2data.GetData();
       /*  if(search && search?.length > 0){
            const ddd = new DDD(apiRequestAddress);
            const args = {
                format : "Full",
                includeCount : true,
                filter : getFilterFromSearch(search, filter, range, range2, type, state, mode),
                skip : startRow,
                take : endRow - startRow,
                orderBy : getOrderByFromArray(sortModel),
                search : search
            }
            setCurrentFilter(getDisplayFilter(search, filter, range, range2, type, state, mode));
            return ddd.Rpc_ExecuteExtension("EUeInvoices.InvoicesSearch", args)

        }else{
            const e2data= new E2Data("EU_VATReports");
            e2data.format="Full"
            e2data.includeCount=true;
            e2data.skip=startRow;
            e2data.take=endRow-startRow;
            e2data.component= "*";
            e2data.filter=getFilterFromSearch(search, filter, range, range2, type, state, mode);
            setCurrentFilter(getDisplayFilter(search, filter, range, range2, type, state, mode));
            e2data.orderBy=getOrderByFromArray(sortModel);
            return e2data.GetData();
        } */
    }

    const getOrderByFromArray = (arr) => {
        if(!arr?.length) return null;

        let order = "";
        arr.forEach(item => order+= item.colId + " " + item.sort+", ");
        order = order.replace(/, +$/, "");
        return order;
    }

    const getDisplayFilter = (globalSearch, filter, _range, _range2, _type, _state, _mode, _source) => {
        let ff = "";
        if(globalSearch && globalSearch.trim() !=="")
            ff=`${t("Global search")}: ${globalSearch}`;
        if(_type && _type!== "null"){
            if(ff) ff += `, ${t("Code")}: ${_type}`;
            else ff += `${t("Code")}: ${_type}`;
        }
        if(_state && _state!== "null"){
            if(ff) ff += `, ${t("Type")}: ${_state}`;
            else ff += `${t("Type")}: ${_state}`;
        }
        if(_source && _source!== "null"){
            if(ff) ff += `, ${t("Source")}: ${_source}`;
            else ff += `${t("Source")}: ${_source}`;
        }
        if(_mode && _mode!== "null"){
            if(ff) ff += `, `;
            /* if(_mode==="PROD") ff += `${t("Mode")}: ${_mode}`;
            if(_mode==="TEST") ff += `${t("Mode")}: ${_mode} OR null`; */
            if(_mode==="PROD") ff += `${t("Mode")}: ${_mode} OR (null and __Mode="PROD")`;
            if(_mode==="TEST") ff += `${t("Mode")}: ${_mode} OR (null and __Mode="TEST")`;
        }
        
        if(_range?.[0]?.startDate && _range?.[0]?.endDate){
            const start = new Date(_range[0].startDate);
            const end = new Date(_range[0].endDate);

            start.setHours(0, 0, 0, 0);              // 00:00:00.000
            end.setHours(23, 59, 59, 999);           // 23:59:59.999

            const startStr = start.toLocaleString('sv-SE').replace(' ', 'T');
            const endStr = end.toLocaleString('sv-SE').replace(' ', 'T');

            if(ff) ff += `, ${dateField}: ${startStr} - ${endStr}`;
            else ff += `${dateField}: ${startStr} - ${endStr}`;
        }

        if(_range2?.[0]?.startDate && _range2?.[0]?.endDate){
            const start = new Date(_range2[0].startDate);
            const end = new Date(_range2[0].endDate);

            start.setHours(0, 0, 0, 0);              // 00:00:00.000
            end.setHours(23, 59, 59, 999);           // 23:59:59.999

            const startStr = start.toLocaleString('sv-SE').replace(' ', 'T');
            const endStr = end.toLocaleString('sv-SE').replace(' ', 'T');

            if(ff) ff += `, ${dateField2}: ${startStr} - ${endStr}`;
            else ff += `${dateField2}: ${startStr} - ${endStr}`;
        }
        return ff;
    }
    const getFilterFromSearch = (globalSearch, filter, _range, _range2, _type, _state,_mode,_source) =>{
        let ff="";
        //if((!globalSearch || globalSearch.trim() ==="") && !filter) return null;
        if (globalSearch && globalSearch.trim() !== "") {
            const trimmed = globalSearch.trim();
            const isNumeric = !isNaN(trimmed) && !isNaN(parseFloat(trimmed));

            if (isNumeric) {
                ff = `SeqNo = ${trimmed} OR UserCreate contains "${trimmed}"`;
            } else {
                ff = `UserCreate contains "${trimmed}"`;
            }
        }
        if(filter){
            if(ff) ff= `(${ff}) AND `;
            ff += filter;
        }
        if(_type && _type!== "null"){
            if(ff) ff= `(${ff}) AND `;
            ff += `ReportType__Code = "${_type}"`;
        }
        if(_state && _state!== "null"){
            if(ff) ff= `(${ff}) AND `;
            ff += `ReportType__PurposeType = "${_state}"`;
        }
        if(_source && _source!== "null"){
            if(ff) ff= `(${ff}) AND `;
            ff += `ReportType__Source = "${_source}"`;
        }
        if(_mode && _mode!== "null"){
            if(ff) ff= `(${ff}) AND `;
            /* if(_mode==="PROD") ff += `Mode = "${_mode}"`;
            if(_mode==="TEST") ff += `(Mode = "${_mode}" OR Mode = null)`; */
            if(_mode==="PROD") ff += `(Mode = "PROD" OR (Mode=null AND DeviceId__Mode="PROD"))`;
            if(_mode==="TEST") ff += `(Mode = "TEST" OR (Mode=null AND DeviceId__Mode="TEST"))`;
        }
        
        if(_range?.[0]?.startDate && _range?.[0]?.endDate){
            const start = new Date(_range[0].startDate);
            const end = new Date(_range[0].endDate);

            start.setHours(0, 0, 0, 0);              // 00:00:00.000
            end.setHours(23, 59, 59, 999);           // 23:59:59.999

            const startStr = start.toLocaleString('sv-SE').replace(' ', 'T');
            const endStr = end.toLocaleString('sv-SE').replace(' ', 'T');

            if (ff) ff = `(${ff}) AND `;
            ff += `${dateField} >= "${startStr}" AND ${dateField} <= "${endStr}"`;
        }

        if(_range2?.[0]?.startDate && _range2?.[0]?.endDate){
            const start = new Date(_range2[0].startDate);
            const end = new Date(_range2[0].endDate);

            start.setHours(0, 0, 0, 0);              // 00:00:00.000
            end.setHours(23, 59, 59, 999);           // 23:59:59.999

            const startStr = start.toLocaleString('sv-SE').replace(' ', 'T');
            const endStr = end.toLocaleString('sv-SE').replace(' ', 'T');

            if (ff) ff = `(${ff}) AND `;
            ff += `${dateField2} >= "${startStr}" AND ${dateField2} <= "${endStr}"`;
        }
        return ff==="" ? null : ff;
    }

    useEffectIgnoreFirst(() =>{
        const dataSource = {
            rowCount: undefined,
            getRows: (reqParams) => {
                reqParams.search = search;
                reqParams.filter = filter;
                reqParams.type = type;
                reqParams.range = range;
                reqParams.range2 = range2;
                reqParams.state = state;
                reqParams.mode = mode;
                reqParams.source = source;
                setRequestParams(reqParams);
                loadEntityData(reqParams).then((res) =>{
                    setTotalRecords(res?.result?.count ?? "-");
                    reqParams.successCallback(res?.result?.data, res?.result?.count);
                });
            }
        }
        table?.current?.api?.setGridOption('datasource', dataSource);
    }, [search, filter, reloadNum, range, range2, state, type, mode,source]);

    const onSelectionChanged = (event) => {
        const selectedNode = event.api.getSelectedNodes()?.[0]; // node object
        const selectedData = selectedNode?.data;
        if(selectedData && onRowSelect) onRowSelect(selectedData);
    };

    const handleRightClick = (event) => {
        event.event.preventDefault();
        if(onRightClick) onRightClick(event?.data, event)
    };


    if(!entityInfo) return null;
    return(
        <div style={{position:"relative", height: '100%', width: '100%' }} className={"ag-theme-balham custom-ag-grid"} onContextMenu={(e) => e.preventDefault()}>
            <AgGridReact
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                rowBuffer={0}
                getRowStyle={rowStyles}
                rowSelection={'single'}
                rowModelType={'infinite'}
                cacheBlockSize={100}
                cacheOverflowSize={2}
                maxConcurrentDatasourceRequests={1}
                infiniteInitialRowCount={1000}
                maxBlocksInCache={10}
                onGridReady={onGridReady}
                ref = {table}
                onSelectionChanged={onSelectionChanged}
                onCellContextMenu={handleRightClick}
            />
            <div style={{
                position: 'absolute',
                bottom: '3px',
                right: '5px',
                cursor: 'pointer',
                zIndex: 10
            }}
                className="tooltip-container"
            >
                <MuiTooltip title={<>
                    <div className="mb-2">{t("Table status")}</div>
                        <p style={{ textAlign: "left", marginBottom: 4 }}>{t("Number od records")}: {totalRecords}</p>
                        {currentFilter!=="" && <p style={{ textAlign: "left", marginBottom: 4 }}>{t("Filter")}: {currentFilter}</p>}
                </>} placement="top">
                    <HelpIcon style={{fontSize:"0.8rem", color:"var(--main-blue)"}}/>
                </MuiTooltip>
                {/* <OverlayTrigger placement="top" 
                    overlay={<Tooltip>
                        <div className="mb-2">{t("Table status")}</div>
                        <p style={{ textAlign: "left", marginBottom: 4 }}>{t("Number od records")}: {totalRecords}</p>
                        {currentFilter!=="" && <p style={{ textAlign: "left", marginBottom: 4 }}>{t("Filter")}: {currentFilter}</p>}
                        </Tooltip>}>
                    <HelpIcon style={{fontSize:"0.8rem", color:"var(--main-blue)"}}/>
                </OverlayTrigger> */}
            </div>
        </div>
    )
});


export default VATReportsTable;

const getInvoiceSourceIcon = (invoiceSource) => {
  const iconStyle = { fontSize: '1rem', color: 'var(--main-blue)' };

  switch (invoiceSource) {
    case 'Internal':
      return <Home style={{ ...iconStyle }} />; // Green - Internal/company
    case 'External':
      return <Public style={{ ...iconStyle }} />; // Orange - External/public
    default:
      return <HelpOutline style={{ ...iconStyle, color: '#9e9e9e' }} />; // Default document icon
  }
};

const getReportTypeIcon = (reportType) => {
  const iconStyle = { fontSize: '1rem', color: 'var(--main-blue)' };

  switch (reportType) {
    case 'VATReturn':
      return <MonetizationOn style={{ ...iconStyle, color: '#f57c00' }} />; // Orange - Tax return
    case 'FISCBalanceSheet':
      return <AccountBalance style={{ ...iconStyle, color: '#1976d2' }} />; // Blue - Financial balance
    case 'VATSalesPurchaseJournal':
      return <Assignment style={{ ...iconStyle, color: '#388e3c' }} />; // Green - Journal/ledger
    case 'FISCDaily':
      return <CalendarToday style={{ ...iconStyle, color: '#7b1fa2' }} />; // Purple - Daily reports
    case 'FISCPeriodical':
      return <Schedule style={{ ...iconStyle, color: '#5d4037' }} />; // Brown - Periodic reports
    case 'FISCe-Journal':
      return <Article style={{ ...iconStyle, color: '#0288d1' }} />; // Light blue - Electronic journal
    case 'FISCCorrective':
      return <Edit style={{ ...iconStyle, color: '#d32f2f' }} />; // Red - Corrections
    case 'FISCOffline':
      return <CloudOff style={{ ...iconStyle, color: '#616161' }} />; // Grey - Offline
    case 'VIES-KP':
        return <Inventory2Icon style={{ ...iconStyle, color: '#0288d1' }} />; // Grey - Offline
    default:
      return <HelpOutline style={{ ...iconStyle, color: '#9e9e9e' }} />; // Default document icon
  }
};

// Function for general categories
const getCategoryIcon = (category) => {
  const iconStyle = { fontSize: '1rem', color: 'var(--main-blue)' };

  switch (category) {
    case 'VAT':
      return <PriceChangeIcon style={{ ...iconStyle, color: '#1976d2' }} />; // Orange - VAT/Tax
    case 'FISC':
      return <SummarizeIcon style={{ ...iconStyle, color: '#1976d2' }} />; // Blue - Fiscal/Financial
    case 'INVOICE':
      return <Receipt style={{ ...iconStyle, color: '#4caf50' }} />; // Green - Invoice
    case 'EINVOICE':
      return <Email style={{ ...iconStyle, color: '#2196f3' }} />; // Blue - Electronic invoice
    case 'OTHER':
      return <Category style={{ ...iconStyle, color: '#9e9e9e' }} />; // Grey - Other/miscellaneous
    default:
      return <HelpOutline style={{ ...iconStyle, color: '#9e9e9e' }} />; // Default document icon
  }
};
/*

*/
const getStatusIcon = (status) => {
    const iconStyle = { 
      fontSize: '1rem', 
      marginRight: '4px',
      verticalAlign: 'middle'
    };

    switch (status) {
      // Approved states
      case 'Approved':
      case 'Accepted':
      case 'ApprovedByReceiver':
        return <ApprovedIcon style={{ ...iconStyle, color: '#43a047' }} />; // Green
      
      // Rejected states
      case 'Rejected':
      case 'RejectedPA':
      case 'RejectedByReceiver':
        return <RejectedIcon style={{ ...iconStyle, color: '#e57373' }} />; // Red
      
      // Received states (including typos)
      case 'Received':
      case 'MessageRecieved': // Typo preserved
      case 'MessageReceived':
        return <MessageIcon style={{ ...iconStyle, color: '#1976d2' }} />; // Blue
      
      // Payment related
      case 'Paid':
      case 'DeliveredPA':
      case 'AcceptedPA':
        return <PaymentIcon style={{ ...iconStyle, color: '#4caf50' }} />; // Green
      
      // Cancelled states (both spellings)
      case 'Cancelled':
      case 'Canceled':
        return <CancelledIcon style={{ ...iconStyle, color: '#f44336' }} />; // Red
      
      // Message states
      case 'MessageSent':
      case 'Sent':
        return <SentIcon style={{ ...iconStyle, color: '#2196f3' }} />; // Blue
      
      // Error states
      case 'Error':
      case 'TAPTechnicalError':
        return <ErrorIcon style={{ ...iconStyle, color: '#ff9800' }} />; // Amber
      
      // Special cases
      case 'Storno':
      case 'StornoOfApprovedInv':
        return <StornoIcon style={{ ...iconStyle, color: '#9c27b0' }} />; // Purple
      case 'Quarrantena':
        return <QuarantineIcon style={{ ...iconStyle, color: '#ff5722' }} />; // Deep orange
      case 'TAPArchived':
        return <ArchivedIcon style={{ ...iconStyle, color: '#607d8b' }} />; // Blue grey
      case 'Seen':
        return <SeenIcon style={{ ...iconStyle, color: '#00bcd4' }} />; // Cyan
      case 'Reminded':
      case 'Renotified':
        return <RemindedIcon style={{ ...iconStyle, color: '#ffc107' }} />; // Amber
      case 'Waiting':
      case 'New':
        return <WaitingIcon style={{ ...iconStyle, color: '#9e9e9e' }} />; // Grey
      
      // Default
      case 'Unknown':
      case 'NotDelivered':
      case 'DeadlineTerms':
      default:
        return <UnknownIcon style={{ ...iconStyle, color: '#9e9e9e' }} />; // Grey
    }
};


const getInvoiceTypeIcon = (invoiceType) => {
    const iconStyle = { fontSize: '1rem', marginRight: '4px', color:"var(--main-blue)" };
  
    switch (invoiceType) {
      case 'INVOICECZ':
        return <Receipt style={{ ...iconStyle, color: '#1976d2' }} />; // Blue
      case 'INVOICESB':
        return <Receipt style={{ ...iconStyle, color: '#388e3c' }} />; // Green
      case 'PROFORMA':
        return <Description style={{ ...iconStyle, color: '#ffa000' }} />; // Amber
      case 'SELFINVOICE':
        return <History style={{ ...iconStyle, color: '#7b1fa2' }} />; // Purple
      case 'CORRECTIVE':
      case 'CORRECTIVECREDITNOTE':
        return <EditNote style={{ ...iconStyle, color: '#d32f2f' }} />; // Red
      case 'PARTIALINVOICE':
      case 'PARTIALFINALCONSTRINVOICE':
        return <AttachMoney style={{ ...iconStyle, color: '#0288d1' }} />; // Light blue
      case 'ADVANCE':
      case 'CORRECTIVEADVANCE':
        return <Paid style={{ ...iconStyle, color: '#689f38' }} />; // Light green
      case 'CREDITNOTE':
        return <CreditScore style={{ ...iconStyle, color: '#5c6bc0' }} />; // Indigo
      case 'FINALCONSTRINVOICE':
      case 'PARTIALCONSTRINVOICE':
        return <ReceiptLong style={{ ...iconStyle, color: '#5d4037' }} />; // Brown
      case 'INVOICE':
      default:
        return <Receipt style={iconStyle} />; // Default
    }
};

const getPaymentTypeIcon = (paymentType) => {
    const iconStyle = { fontSize: '1rem', marginRight: '4px', color: 'var(--main-blue)' };
  
    switch (paymentType) {
      case 'CASH':
        return <Payments style={{ ...iconStyle, color: '#43a047' }} />; // Green (cash payment icon)
      case 'NONCASH':
        return <AccountBalanceIcon style={{ ...iconStyle, color: '#1976d2' }} />
      case 'COMBINE':
        return <MonetizationOn style={{ ...iconStyle, color: '#f9a825' }} />; // Amber (money with dollar)
      default:
        return <HelpOutline style={{ ...iconStyle, color: '#9e9e9e' }} />; // Grey question mark
    }
};

const getSaleTypeIcon = (saleType) => {
    const iconStyle = { fontSize: '1rem', marginRight: '4px', color: 'var(--main-blue)' };
  
    switch (saleType) {
      case 'Retailsale':
        return <Storefront style={{ ...iconStyle, color: '#4caf50' }} />; // Green - Retail shop
      case 'Wholesale':
        return <BusinessCenter style={{ ...iconStyle, color: '#1976d2' }} />; // Blue - Briefcase for business
      case null:
      case 'null':
      default:
        return <HelpOutline style={{ ...iconStyle, color: '#9e9e9e' }} />; // Gray - Unknown/default
    }
};
/*style={{ cursor: 'pointer' }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    window.open(previewPrefix+"/"+selectedRow.PDFPrimary, '_blank');
                                }}*/
const getPDFOriginalIcon = (pdfOriginal) => {
    const iconStyle = { fontSize: '1rem', marginRight: '4px', color: 'var(--main-blue)' };
  
    if(pdfOriginal) {
        return <PictureAsPdfIcon style={{ ...iconStyle, color: '#4caf50', cursor: 'pointer' }}  onClick={(e) => {e.stopPropagation(); window.open("/"+pdfOriginal, '_blank');}}/>; 
    }
    return <PictureAsPdfIcon style={{ ...iconStyle, color: '#9e9e9e' }} />; // Gray - Unknown/default
};

const TapHeaderComponent = (props) => {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        <OverlayTrigger placement="top" overlay={<Tooltip>{"Tax Authority Portal"}</Tooltip>}>
            <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" 
                        fill="var(--main-blue)" 
                        stroke="black" 
                        stroke-width="1"/>
                <text x="12" y="15" 
                        font-family="Arial, sans-serif" 
                        font-size="8" 
                        font-weight="bold" 
                        text-anchor="middle" 
                        fill="white">TAP</text>
            </svg>
        </OverlayTrigger>
        <span>{props.displayName}</span>
      </div>
    );
}

const mergeObjects = (obj1, obj2) => {
    if (obj2) {
        for (const key in obj2) {
            if(!obj2[key].sort) obj2[key].sort = undefined; // Ensure sort is always defined
            if(!obj2[key].sortIndex && obj2[key].sortIndex !==0) obj2[key].sortIndex = undefined; // Ensure sort is always defined
            obj1[key] = {
            ...obj1[key],
            ...obj2[key],
            };
        }
    }
    return obj1;
}

/**
 * Returns the number of decimal places for a currency (from ISO 4217).
 * Defaults to 2 if currency is unknown.
 */
const getCurrencyDecimals = (currencyCode) => {
  if (!currencyCode) return 2;

  // All exceptions (currencies NOT using 2 decimals)
  // Source: https://en.wikipedia.org/wiki/ISO_4217
  const currencyDecimals= {
    // 0 decimals
    'BIF': 0, 'CLP': 0, 'DJF': 0, 'GNF': 0, 'ISK': 0, 'JPY': 0,
    'KMF': 0, 'KRW': 0, 'PYG': 0, 'RWF': 0, 'UGX': 0, 'VND': 0, 'VUV': 0,
    'XAF': 0, 'XOF': 0, 'XPF': 0,

    // 1 decimal
    'MGA': 1, 'MRU': 1,

    // 3 decimals
    'BHD': 3, 'IQD': 3, 'JOD': 3, 'KWD': 3, 'LYD': 3, 'OMR': 3, 'TND': 3,

    // 4 decimals (very rare)
    'CLF': 4,
  };

  return currencyDecimals[currencyCode.toUpperCase()] ?? 2; // Default: 2
}
const formatCurrencyDecimal = (currencyCode, value) => {
    if (value === null || value === undefined) return null;

    const numericValue = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(numericValue)) return null;

    const decimals = getCurrencyDecimals(currencyCode);
    const factor = 10 ** decimals;
    const roundedValue =  Math.round(numericValue * factor) / factor;
    return roundedValue.toFixed(decimals);
}